<form
	#editForm="ngForm"
	[formReset]="editForm"
	(ngSubmit)="editForm.valid && submit()">
	<div class="modal-header">
		<h4
			class="modal-title"
			*ngIf="!loading">
			{{'labels.' + title | translate}}
		</h4>
		<button
			type="button"
			class="close"
			aria-label="Close"
			(click)="dismiss()">
			<span aria-hidden="true">×</span>
		</button>
	</div>
	<div
		class="modal-body"
		ngbAutofocus>
		<div
			class="row"
			*ngIf="loading">
			<div class="col text-center">
				<app-loader [material]="false"></app-loader>
			</div>
		</div>

		<div
			class="row"
			*ngIf="!loading && deliverable">
			<div class="col-sm-12">
				<div class="row">
					<!-- company -->
					<div class="form-group col-md-4">
						<label for="company">{{ 'labels.milestone' | translate }}*</label>

						<app-entity-autocomplete
							[loadonfocus]="true"
							entityName="milestone"
							entityField="name"
							entityFilterType="like"
							[entitySearch]="search.milestone"
							name="milestone"
							[(ngModel)]="selected.milestone"
							placeholder
							required
							#milestoneeautocomp="ngModel"
							[ngClass]="{'is-invalid': editForm.submitted && milestoneeautocomp.invalid}">
						</app-entity-autocomplete>
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && milestoneeautocomp.invalid"
							style="display: block;">
							{{'errors.required' | translate}}
						</div>

					</div>

					<!-- name -->
					<div class="form-group col-md-4">
						<label for="name">{{ 'labels.name' | translate }}*</label>
						<input
							[(ngModel)]="deliverable.name"
							#name="ngModel"
							name="name"
							required
							type="text"
							class="form-control"
							placeholder="{{ 'labels.name' | translate }}"
							[ngClass]="{'is-invalid': editForm.submitted && name.invalid}">
						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && name.invalid">
							{{'errors.required' | translate}}
						</div>
					</div>

					<!-- type -->
					<div class="form-group col-md-4">
						<label for="deliverabletype">{{ 'labels.type' | translate }}*</label>

						<app-list-items-selector
							list="deliverable.type"
							name="deliverabletype"
							[(ngModel)]="deliverable.deltype"
							#deliverabletype="ngModel"
							[inputClass]="{'is-invalid': editForm.submitted && deliverabletype.invalid}">
						</app-list-items-selector>

						<div
							class="invalid-feedback"
							*ngIf="editForm.submitted && deliverabletype.invalid">
							{{'errors.invalid' | translate}}
						</div>

					</div>
					<div class="col-md-12">
						<label for="deliverabletype">{{ 'labels.attachment' | translate }}</label>
						<br>
						{{attach?.filename}}
						<el-attachment-input
							[extradata]="{'company' : companyid}"
							#deliverableattachment
							entity="deliverable"
							[eid]="deliverable.id">
						</el-attachment-input>
					</div>
				</div>

			</div>
		</div>

	</div>
	<div class="modal-footer">

		<button
			type="reset"
			class="btn btn-secondary">
			{{'labels.reset' | translate}}
		</button>
		<button
			type="button"
			class="btn btn-secondary"
			(click)="dismiss()">
			{{'labels.cancel' | translate}}
		</button>
		<button
			type="submit"
			class="btn btn-primary">
			{{'labels.save' | translate}}
		</button>
	</div>
</form>
